<script lang="ts">
    import { tick } from "svelte";
    import { portal } from "../portal";

    // Hover-tooltip с portal'ингом в <body> — чтобы не клипался overflow
    // родителями (таблица, скролл-контейнеры) и не вызывал layout-shift
    // в строке/ячейке-trigger'е.
    export let content: string = "";
    export let placement: "bottom" | "top" = "bottom";

    let visible = false;
    let triggerEl: HTMLSpanElement;
    let tipEl: HTMLSpanElement;
    let style = "";

    async function show() {
        if (!content) return;
        visible = true;
        await tick();
        position();
    }
    function hide() {
        visible = false;
    }

    function position() {
        if (!triggerEl || !tipEl) return;
        const r = triggerEl.getBoundingClientRect();
        const tipW = tipEl.offsetWidth;
        const tipH = tipEl.offsetHeight;
        let top: number;
        if (placement === "bottom") {
            top = r.bottom + 6;
        } else {
            top = r.top - tipH - 6;
        }
        let left = r.left + r.width / 2 - tipW / 2;
        // keep within viewport horizontally
        const margin = 6;
        if (left < margin) left = margin;
        if (left + tipW > window.innerWidth - margin)
            left = window.innerWidth - tipW - margin;
        style = `position:fixed; top:${top}px; left:${left}px;`;
    }
</script>

<span
    class="inline-flex"
    bind:this={triggerEl}
    on:mouseenter={show}
    on:mouseleave={hide}
    on:focusin={show}
    on:focusout={hide}
>
    <slot />
</span>

{#if visible && content}
    <span
        use:portal
        bind:this={tipEl}
        {style}
        class="z-[300] w-max max-w-[24rem] whitespace-pre rounded-md border border-[var(--border)] bg-[var(--popover)] text-[var(--popover-foreground)] px-2.5 py-1.5 text-xs shadow-lg pointer-events-none"
    >
        {content}
    </span>
{/if}
